import {
  LeadFormCmsItem,
  LeadFormFieldKey,
  LeadFormPageType,
  InteractionType,
} from "./types";

/**
 * Resolves a field key from a CMS item's shortDescription/internalName.
 * Same pattern as signupform.tsx getFieldKey — shortDescription is the primary identifier.
 */
export const getLeadFormFieldKey = (item: LeadFormCmsItem): LeadFormFieldKey => {
  const desc = item.shortDescription?.toLowerCase()?.trim();

  if (desc === "enquiry" || desc === "yourenquiry") return "enquiry";
  if (desc === "firstname") return "firstName";
  if (desc === "lastname") return "lastName";
  if (desc === "email") return "email";
  if (desc === "password") return "password";
  if (desc === "yearofentry" || desc === "whenwillyoustart") return "yearOfEntry";
  if (desc === "studylevel") return "studyLevel";
  if (desc === "postcode") return "postcode";
  if (desc === "opendayselector" || desc === "openday") return "openDaySelector";
  if (desc === "countryofresidence" || desc === "country") return "countryOfResidence";
  if (desc === "stayinknow") return "stayInKnow";
  if (desc === "uninewsletter") return "uniNewsletter";
  if (desc === "addressblock" || desc === "addressfields" || desc === "addressfinder" || desc === "postcodefinder") return "addressBlock";
  if (desc === "addressline1" || desc === "addressline2" || desc === "towncity" || desc === "town" || desc === "addresspostcode" || desc === "countryselector" || desc === "worldcountry") return "addressBlock";

  // Fallback to internalName when shortDescription is not a field key
  const name = item.internalName?.toLowerCase()?.trim();
  if (name?.includes("sitk") || name?.includes("stayinknow")) return "stayInKnow";
  if (name?.includes("uninewsletter")) return "uniNewsletter";
  if (name?.includes("yoe") || name?.includes("yearofentry")) return "yearOfEntry";
  if (name?.includes("addressfinder") || name?.includes("postcodefinder") || name?.includes("addressline") || name?.includes("address line") || name?.includes("towncity") || name?.includes("town/city") || name?.includes("addresspostcode") || name?.includes("countryselector") || name?.includes("world country") || name?.includes("addressblock")) return "addressBlock";
  if (name?.includes("countryofresidence") || name?.includes("country of residence")) return "countryOfResidence";
  if (name?.includes("postcode")) return "postcode";
  if (name?.includes("enquiry")) return "enquiry";
  if (name?.includes("openday")) return "openDaySelector";
  if (name?.includes("studylevel")) return "studyLevel";

  return "unknown";
};

/** Check if a specific field key exists in the CMS items */
export const hasField = (
  cmsItems: LeadFormCmsItem[],
  key: LeadFormFieldKey,
): boolean => cmsItems.some((item) => getLeadFormFieldKey(item) === key);

/** Maps pageType to the interaction type for the BFF API */
export const getInteractionType = (pageType: LeadFormPageType): InteractionType => {
  switch (pageType) {
    case "requestinfo":
      return "REQUEST_INFO";
    case "opendays":
      return "OPEN_DAY";
    case "digitalprospectus":
      return "GET_PROSPECTUS_DIGITAL";
    case "physicalprospectus":
      return "GET_PROSPECTUS_PHYSICAL";
    default:
      return "REQUEST_INFO";
  }
};

/** Maps pageType to the Contentful URL slug for fetching form config */
export const getFormUrlSlug = (pageType: LeadFormPageType, step?: number): string => {
  switch (pageType) {
    case "requestinfo":
      return "forms/request-info";
    case "opendays":
      return "/forms/open-days";
    case "digitalprospectus":
      return "/forms/digital-prospectus";
    case "physicalprospectus":
      return step === 1
        ? "/forms/order-prospectus-step2"
        : "/forms/order-prospectus-step1";
    default:
      return "/forms/request-info";
  }
};
